import React, { Component } from "react";
import lang from "../lang/index";
import Contact from "./contact";
import resetpwdpb from "../resetpwd";
import publicpb from "../publicpb";
import md5 from "../md5";
import PbAjax from "up-pbajax";
import loading from "c-loading";
import Notification from "./notification";
import notification from "c-notification";
import url from "c-url";
import ResetPwdSuccess from "./reset-success";

const pbajax = new PbAjax();

class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorNotice: "",
            resetResult: 0,
            buttonCanClick: 0,
        };
    }
    onChange(e) {
        let reg = /[^0-9a-zA-Z]/gi;
        let val = e.target.value;
        e.target.value = val.replace(reg, "");
        if (val.length > 20) {
            e.target.value = val.slice(0, 20);
        }
    }
    onBlur(e) {
        let value = e.target.value;
        let buttonCanClick;
        let isPwdOk = this.verifyPwd(value);
        if (!isPwdOk) {
            this.refs.errorNotice.innerHTML = lang.template("密码格式错误");
        } else if (
            this.refs.resetpassword.value != "" &&
            this.refs.resetpassword.value != value
        ) {
            this.refs.errorNotice.innerHTML =
                lang.template("两次输入的密码必须一致");
        } else {
            this.refs.errorNotice.innerHTML = "";
        }
        if (isPwdOk && this.refs.resetpassword.value == value) {
            buttonCanClick = 1;
        } else {
            buttonCanClick = 0;
        }
        this.setState({
            buttonCanClick: buttonCanClick,
        });
    }
    confirmPassword = (e) => {
        let buttonCanClick;
        let resetPwd = this.refs.password.value;
        let repeatPwd = e.target.value;
        let nowLength = repeatPwd.length; // resetPwd != e.target.value
        if (resetPwd.slice(0, nowLength) != repeatPwd.slice(0, nowLength)) {
            this.refs.errorNotice.innerHTML =
                lang.template("两次输入的密码必须一致");
        } else {
            this.refs.errorNotice.innerHTML = "";
        }

        if (
            this.verifyPwd(resetPwd) &&
            this.refs.password.value == e.target.value
        ) {
            buttonCanClick = 1;
        } else {
            buttonCanClick = 0;
        }
        this.setState({
            buttonCanClick: buttonCanClick,
        });
    };
    verifyPwd(value) {
        let reg = /([a-zA-Z0-9]){6,20}/gi;
        if (!reg.test(value)) {
            return false;
        } else {
            return true;
        }
    }
    submit(e) {
        let button = e.target;

        button.disabled = "disabled";
        if (!this.verifyPwd(this.refs.password.value)) {
            this.refs.errorNotice.innerHTML = lang.template("密码格式错误");
            button.disabled = false;
            return false;
        }
        if (this.refs.password.value != this.refs.resetpassword.value) {
            this.refs.errorNotice.innerHTML =
                lang.template("两次输入的密码必须一致");
            button.disabled = false;
            return false;
        }

        loading.show();

        let data = {
            bindType: "EMAIL",
            thirdId: "",
            verifyCode: url.query("code"),
            password: md5.hex_md5(this.refs.password.value),
        };

        let ua =
            window.navigator.userAgent +
            (lang.businessType == "upVoice" ? " feature/6666" : "");

        pbajax.do(
            {
                service: "account",
                api: "/user/set/password",
                header: {
                    UserAgent: ua,
                },
                inchina: 1,
            },
            new resetpwdpb.User.SetPassword.Request(data),
            (res) => {
                loading.hide();
                button.disabled = false;
                let dataWrap = publicpb.Result.decode(res);

                if (dataWrap.code == 1) {
                    this.setState({
                        resetResult: "success",
                    });
                } else {
                    notification.simple(lang.template("重置密码失败"));
                }
            },
            () => {
                loading.hide();
                button.disabled = false;
                new Notification({
                    content: lang.template("网络连接有误, 请稍后再试"),
                }).create();
            }
        );
    }

    render() {
        const isHujing = url.query("feature") == 224;
        let resetResult = this.state.resetResult;
        let buttonCanClick = this.state.buttonCanClick;
        let buttonActiveClass = "confirm-button";
        if (buttonCanClick == 1) {
            buttonActiveClass = "confirm-button confirm-button-active";
        }

        if (isHujing) {
            buttonActiveClass = buttonActiveClass.replace(
                /confirm-button/g,
                () => "confirm-button-hj"
            );
        }
        let appName = url.query('appname') || null;
        let render = (
            <div>
                {appName ? null : <div className={isHujing ? "hujing-logo" : "logo"}></div>}
                <div className="verify-result reset-password">
                    <h1 className="reset-title">
                        {lang.template("请重新设定登录密码")}
                    </h1>

                    <div className="verify-result reset">
                        <div className="out-input">
                            <input
                                type="password"
                                placeholder={lang.template("请重新设置密码")}
                                onBlur={this.onBlur.bind(this)}
                                onChange={this.onChange.bind(this)}
                                className={
                                    isHujing ? "class-input-hj" : "class-input"
                                }
                                ref="password"
                            />
                        </div>

                        <div className="out-input">
                            <input
                                type="password"
                                placeholder={lang.template("请再次输入密码")}
                                className={
                                    isHujing ? "class-input-hj" : "class-input"
                                }
                                onChange={this.confirmPassword}
                                ref="resetpassword"
                            />
                        </div>

                        <div className="reset-notice">
                            <span className="error" ref="errorNotice"></span>
                            <span className="password-notice">
                                {lang.template("密码由6-20位由数字和字母组成")}
                            </span>
                        </div>
                    </div>

                    <input
                        className={buttonActiveClass}
                        type="button"
                        value={lang.template("确认修改")}
                        onClick={this.submit.bind(this)}
                        ref="confirmButton"
                    />
                </div>
            </div>
        );

        if (resetResult == "success") {
            render = <ResetPwdSuccess />;
        }

        return <div>{render}</div>;
    }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./js/view/reset-password.js